module.exports = __webpack_public_path__ + "static/media/image13.496ba529.jpg";